// extracted by mini-css-extract-plugin
module.exports = {"body":"_3-xsSZN4RLdb7EqlySYuPb","titleWrapper":"_2chuGH5ehSHKapV6DFd0iH","h2":"_2-bZXCna4WfT3Q-ugj4GUb"};